@if (initialized && snapshotId) {
    <div class="cn-decision-snapshot surface-0 border-1 surface-border border-round p-3">

        <div class="flex align-items-center gap-2 mb-3">
            <i class="fa-regular fa-file-shield text-xl text-primary"></i>
            <span class="text-lg font-medium">Entscheidungs-Snapshot</span>
        </div>

        @if (loading) {
            <p-skeleton height="6rem" class="block mb-2"></p-skeleton>
        }

        @if (errorMessage) {
            <p-message severity="error" class="block mb-2" [text]="errorMessage"></p-message>
        }

        @if (hasSnapshot()) {
            <!-- Audit summary (immutable, revision-proof) -->
            <div class="grid mb-3">
                <div class="col-6 md:col-3">
                    <div class="text-xs text-600">NPV aktiv</div>
                    <div class="font-semibold">
                        {{ snapshot.npvActive | currency:'EUR':'symbol':'1.0-0':'de' }}
                    </div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="text-xs text-600">NPV bestes Szenario</div>
                    <div class="font-semibold">
                        {{ snapshot.npvScenarioBest | currency:'EUR':'symbol':'1.0-0':'de' }}
                    </div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="text-xs text-600">Horizont</div>
                    <div class="font-semibold">{{ snapshot.horizonYears }} Jahre</div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="text-xs text-600">Diskontrate</div>
                    <div class="font-semibold">
                        {{ snapshot.discountRatePercent | number:'1.0-2':'de' }} %
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="text-xs text-600">Versions-Pin / Hash</div>
                    <div class="font-mono text-sm">
                        {{ snapshot.versionPin || '–' }}
                        @if (snapshot.versionHash) {
                            <span class="text-500"> · {{ snapshot.versionHash }}</span>
                        }
                    </div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="text-xs text-600">Freigegeben von</div>
                    <div class="font-semibold">{{ snapshot.approvedBy || '–' }}</div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="text-xs text-600">Freigegeben am</div>
                    <div class="font-semibold">
                        {{ snapshot.approvedAt ? (snapshot.approvedAt | date:'dd.MM.yyyy HH:mm') : '–' }}
                    </div>
                </div>
            </div>
        }

        <!-- Detail widget with the framework export toolbar (CSV / Excel) -->
        @if (snapshotWidget) {
            <mvs-widget [widgetData]="snapshotWidget"></mvs-widget>
        }

    </div>
}
